import React from 'react';
import PropTypes from 'prop-types';

const IconCheck = ({ size, fill }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill={fill}
        viewBox="0 0 24 24"
    >
        <path d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z" />
    </svg>
);

IconCheck.propTypes = {
    size: PropTypes.number.isRequired,
    fill: PropTypes.string.isRequired,
};

IconCheck.defaultProps = {
    size: 12,
    fill: '#45D16D',
};

IconCheck.displayName = 'Check';

export default IconCheck;
